<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    <template v-if="value" v-html="value"></template>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isCondensed'],

	computed: {

		value: function() {

			var parts = this.item.user && this.item.user.parts
			if (!parts || !parts.length) return ''
			return parts.map(function(p) { return p.text }).filter(function(t) { return t }).join('<br />')

		}

	}

}

</script>
